<template>
  <!--
        作者：luoyiming
        时间：2019-10-25
        描述：会员-用户列表-会员等级
    -->
  <el-dialog title="推广员编辑" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="姓名" :label-width="formLabelWidth">
        <el-input v-model="form.user.username" :disabled="true" />
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.mobile" :disabled="true" />
      </el-form-item>
      <el-form-item label="等级名称" :label-width="formLabelWidth">
        <el-select v-model="form.grade_id" placeholder="-请选择等级-">
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="余额" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.balance" />
      </el-form-item>
      <el-form-item label="已提现金额" :label-width="formLabelWidth">
        <el-input type="number" v-model="form.cash" placeholder="请输入已提现金额" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PromotionApi from "@/api/promotion.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      gradeList: []
    };
  },
  props: ["open_edit", "form"],
  created() {
    this.dialogVisible = this.open_edit;
    this.getgradeList();
    // console.log(999, this.form);
  },
  methods: {
    getgradeList() {
      let self = this;
      let params = {};
      Params.pageIndex = 1;
      Params.pageSize = 10000;
      PromotionApi.PromotionGrade(params, true)
        .then(data => {
          self.loading = false;
          self.gradeList = data.data.data;
          // console.log(999, self.gradeList);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*修改用户*/
    editUser() {
      let self = this;
      self.loading = true;
      let params = self.form;
      PromotionApi.PromotionEdit(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: "恭喜你，用户修改成功",
              type: "success"
            });
            self.dialogFormVisible(true);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/list/dialog/Grade.vue